import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { AppBar, Box, Button, Typography, Avatar } from "@mui/material";
import unileverLogo from "../../../assets/images/logo-pc.png"; //  Unilever logo
import headerLogo from "../../../assets/images/header-logo.png"; //  Unilever logo
import useLocalStorage from "../../../hooks/useLocalStorage";
import { useAppContext } from '../../../hooks/context/AppContext';
import { projectVersion } from "../../../config/navConfig";


const Header: React.FC = () => {
  const { appData, updateAppData } = useAppContext();
  const [userInfo] = useLocalStorage("user_info", null);
  const navigate = useNavigate();
  const location = useLocation();

  // detect version by path

  let handleHomeClick = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/`);
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: `/` });
    }
  }

  return (
    <AppBar
      position="static"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: "60px", //  Reduce height for compact look
        backgroundColor: "#0066DA", //  Match blue color in image
        padding: "0 10px",
        // background:' rgb(26,42,255)',
        background: 'linear-gradient(90deg, rgba(26,42,255,1) 0%, rgba(6,48,249,1) 32%, rgba(49,120,205,1) 72%, rgba(129,110,219,1) 100%)!important',

        position: 'sticky',
        top: 0,
        zIndex: 1

      }}
    >
      {/*  Left: Logo with White Background */}
      <Box
        sx={{
          backgroundColor: "white",
          padding: "2px 2px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <span  onClick={() => handleHomeClick()} style={{ textDecoration: "none", cursor: 'pointer' }}>
          <img src={unileverLogo} alt="Unilever Logo" style={{ height: "54px" }} />
        </span>
      </Box>
      <img src={headerLogo} alt="Header Logo" style={{ height: "42px" }} />
      {/*  Middle: Text */}
      <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", paddingLeft: "15px" }}>
      </Box>
       {/* View Delete Projects Button */}

       {
          userInfo && JSON.parse(userInfo).Role === "Admin" ?
            <> 
                <Button
                  variant="contained"
                  onClick={() => navigate(`${projectVersion}/deleted-projects`)}
                  sx={{
                    backgroundColor: "#00E6A0",
                    color: "black",
                    fontSize: "12px",
                    textTransform: "none",
                    borderRadius: "20px",
                    padding: "5px 15px",
                    "&:hover": { backgroundColor: "#00CC8E" },
                  }}
                >
                  Deleted Projects
                </Button>

              {/* Separator */}
              <Box
                sx={{
                  height: "25px",
                  width: "1px",
                  backgroundColor: "white",
                  marginX: "15px",
                }}
              />
            </>
            :
            null
        }
      {/*  Right: Button & Profile */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* View SharePoint Button */}
        
        {
          userInfo && JSON.parse(userInfo).Role === "Admin" ?
            <>
              <a
                href="https://unilever.sharepoint.com/sites/HomeCareProject/Lists/MasterLookup/AllItems.aspx"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#00E6A0",
                    color: "black",
                    fontSize: "12px",
                    textTransform: "none",
                    borderRadius: "20px",
                    padding: "5px 15px",
                    "&:hover": { backgroundColor: "#00CC8E" },
                  }}
                >
                  Manage Metadata
                </Button>
              </a>

              {/* Separator */}
              <Box
                sx={{
                  height: "25px",
                  width: "1px",
                  backgroundColor: "white",
                  marginX: "15px",
                }}
              />
            </>
            :
            null
        }



        {/* View Dashboard Button */} 
        <a
          href="https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/4747a6f17c845d306492?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#00E6A0",
              color: "black",
              fontSize: "12px",
              textTransform: "none",
              borderRadius: "20px",
              padding: "5px 15px",
              "&:hover": { backgroundColor: "#00CC8E" },
            }}
          >
            View Dashboard
          </Button>
        </a>

        {/* Separator */}
        <Box
          sx={{
            height: "25px",
            width: "1px",
            backgroundColor: "white",
            marginX: "15px",
          }}
        />

        {/* User Profile */}
        <Typography sx={{ fontSize: "12px", color: "white", marginRight: "5px" }}>
          {
            userInfo ? `${JSON.parse(userInfo).FullName} (${JSON.parse(userInfo).Role})` : 'firstname.lastname'
          }

        </Typography>
        <Avatar sx={{ width: 24, height: 24, marginRight: "20px" }} />
      </Box>
    </AppBar>
    
  );
};

export default Header;
